<template>
<v-card>
  <v-toolbar dense>
    <v-toolbar-title>{{title}}</v-toolbar-title>
  </v-toolbar>

  <v-list >
    <template>
      <v-list-tile>
        <v-list-tile-content class="py-1">
          <router-link to="/training/training1" style="text-decoration: none">
            <div class="px-4 ">Workplace Harassment Prevention</div>
          </router-link>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content class="py-1">
          <router-link to="/training/training3" style="text-decoration: none">
            <div class="px-4 ">WHMIS 2015</div>
          </router-link>
        </v-list-tile-content>
      </v-list-tile>    
    </template>
  </v-list>
</v-card>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      required: false,
    }
  },
}
</script>